'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdInvertColors = function MdInvertColors(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 32.7v-24.2l-7 7.1c-1.9 1.8-3 4.4-3 7.1 0 5.3 4.6 10 10 10z m9.5-19.5c5.2 5.2 5.2 13.6 0 18.8-2.6 2.6-6.1 3.9-9.5 3.9s-6.9-1.3-9.5-3.9c-5.2-5.2-5.2-13.6 0-18.8l9.5-9.4z' })
        )
    );
};

exports.default = MdInvertColors;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/invert-colors.js
// module id = 3451
// module chunks = 168707334958949